// Freight accessorial service codes stored per carrier under CustomAttributes.accessorials.
// Listed in carrier code order to stay diffable against the carrier's published list; the dropdown
// sorts them by label for display. The '*' code is a real code (misc freight charge), not a wildcard.
const carrierAccessorials = [
	{ value: '*', label: 'Misc Freight Charge' },
	{ value: 'AIRDEL', label: 'Airport Delivery' },
	{ value: 'AIRPU', label: 'Airport Pickup' },
	{ value: 'APPT', label: 'Delivery Appointment' },
	{ value: 'BLIND', label: 'Blind Shipment' },
	{ value: 'CAMPDEL', label: 'Camp Delivery' },
	{ value: 'CAMPPU', label: 'Camp Pickup' },
	{ value: 'CFSDEL', label: 'Container Freight Station Delivery' },
	{ value: 'CFSPU', label: 'Container Freight Station Pickup' },
	{ value: 'CHRCDEL', label: 'Church Delivery' },
	{ value: 'CHRCPU', label: 'Church Pickup' },
	{ value: 'CLUBDEL', label: 'Country Club Delivery' },
	{ value: 'CLUBPU', label: 'Country Club Pickup' },
	{ value: 'CNVDEL', label: 'Trade Show Delivery' },
	{ value: 'CNVPU', label: 'Trade Show Pickup' },
	{ value: 'CONDEL', label: 'Construction Site Delivery' },
	{ value: 'CONPU', label: 'Construction Site Pickup' },
	{ value: 'DOCKPU', label: 'Dock Pickup (Will Call)' },
	{ value: 'EDUDEL', label: 'School Delivery' },
	{ value: 'EDUPU', label: 'School Pickup' },
	{ value: 'ELS_10', label: 'Excessive Length, 10ft' },
	{ value: 'ELS_11', label: 'Excessive Length, 11ft' },
	{ value: 'ELS_12', label: 'Excessive Length, 12ft' },
	{ value: 'ELS_13', label: 'Excessive Length, 13ft' },
	{ value: 'ELS_14', label: 'Excessive Length, 14ft' },
	{ value: 'ELS_15', label: 'Excessive Length, 15ft' },
	{ value: 'ELS_16', label: 'Excessive Length, 16ft' },
	{ value: 'ELS_17', label: 'Excessive Length, 17ft' },
	{ value: 'ELS_18', label: 'Excessive Length, 18ft' },
	{ value: 'ELS_19', label: 'Excessive Length, 19ft' },
	{ value: 'ELS_20', label: 'Excessive Length, 20ft' },
	{ value: 'ELS_21', label: 'Excessive Length, 21ft' },
	{ value: 'ELS_22', label: 'Excessive Length, 22ft' },
	{ value: 'ELS_23', label: 'Excessive Length, 23ft' },
	{ value: 'ELS_24', label: 'Excessive Length, 24ft' },
	{ value: 'ELS_25', label: 'Excessive Length, 25ft' },
	{ value: 'ELS_26', label: 'Excessive Length, 26ft' },
	{ value: 'ELS_27', label: 'Excessive Length, 27ft' },
	{ value: 'ELS_28', label: 'Excessive Length, 28ft' },
	{ value: 'ELS_29', label: 'Excessive Length, 29ft' },
	{ value: 'ELS_30', label: 'Excessive Length, 30ft and over' },
	{ value: 'ELS_6', label: 'Excessive Length, 6ft' },
	{ value: 'ELS_7', label: 'Excessive Length, 7ft' },
	{ value: 'ELS_8', label: 'Excessive Length, 8ft' },
	{ value: 'ELS_9', label: 'Excessive Length, 9ft' },
	{ value: 'FARMDEL', label: 'Farm Delivery' },
	{ value: 'FARMPU', label: 'Farm Pickup' },
	{ value: 'FLTBDEL', label: 'Flatbed Delivery' },
	{ value: 'GOVDEL', label: 'Government Site Delivery' },
	{ value: 'GOVPU', label: 'Government Site Pickup' },
	{ value: 'GRODEL', label: 'Grocery Warehouse Delivery' },
	{ value: 'GROPU', label: 'Grocery Warehouse Pickup' },
	{ value: 'GS10', label: 'Guaranteed by 10AM' },
	{ value: 'GS11', label: 'Guaranteed by 11AM' },
	{ value: 'GS14', label: 'Guaranteed by 2PM' },
	{ value: 'GS15', label: 'Guaranteed by 3PM' },
	{ value: 'GS1530', label: 'Guaranteed by 3:30PM' },
	{ value: 'GS8', label: 'Guaranteed by 8AM' },
	{ value: 'GS9', label: 'Guaranteed by 9AM' },
	{ value: 'GSAM', label: 'Guaranteed by 12PM' },
	{ value: 'GSMUL', label: 'Guaranteed Multi-Hour Window' },
	{ value: 'GSSING', label: 'Guaranteed Single-Hour Window' },
	{ value: 'GUR', label: 'Guaranteed by 5PM' },
	{ value: 'GURWIN', label: 'Guaranteed by Hour' },
	{ value: 'HAZM', label: 'Hazardous Material' },
	{ value: 'HOSDEL', label: 'Hospital Delivery' },
	{ value: 'HOSPU', label: 'Hospital Pickup' },
	{ value: 'HOTLDEL', label: 'Hotel Delivery' },
	{ value: 'HOTLPU', label: 'Hotel Pickup' },
	{ value: 'INDEL', label: 'Inside Delivery' },
	{ value: 'INPU', label: 'Inside Pickup' },
	{ value: 'LGDEL', label: 'Lift Gate Delivery' },
	{ value: 'LGPU', label: 'Lift Gate Pickup' },
	{ value: 'LTDDEL', label: 'Limited Access Delivery' },
	{ value: 'LTDPU', label: 'Limited Access Pickup' },
	{ value: 'MANDEL2', label: '2 Man Delivery' },
	{ value: 'MANDEL3', label: '3 Man Delivery' },
	{ value: 'MANDEL4', label: '4 Man Delivery' },
	{ value: 'MILDEL', label: 'Military Installation Delivery' },
	{ value: 'MILPU', label: 'Military Installation Pickup' },
	{ value: 'MINEDEL', label: 'Mine Site Delivery' },
	{ value: 'MINEPU', label: 'Mine Site Pickup' },
	{ value: 'NOTIFY', label: 'Notify Consignee' },
	{ value: 'PFZ', label: 'Protection From Freezing' },
	{ value: 'PIERDEL', label: 'Pier Delivery' },
	{ value: 'PIERPU', label: 'Pier Pickup' },
	{ value: 'PRISDEL', label: 'Prison Delivery' },
	{ value: 'PRISPU', label: 'Prison Pickup' },
	{ value: 'RDNS', label: 'Residential Direct No Signature' },
	{ value: 'RDRC', label: 'Residential Direct Room of Choice Service' },
	{ value: 'RDTH', label: 'Residential Direct Threshold' },
	{ value: 'RDWG', label: 'Residential Direct White Glove Service' },
	{ value: 'RDWG20', label: 'Residential Direct White Glove Service 20 min' },
	{ value: 'RDWG30', label: 'Residential Direct White Glove Service 30 min' },
	{ value: 'RDWG45', label: 'Residential Direct White Glove Service 45 min' },
	{ value: 'RDWG60', label: 'Residential Direct White Glove Service 60 min' },
	{ value: 'RESDEL', label: 'Residential Delivery' },
	{ value: 'RESPU', label: 'Residential Pickup' },
	{ value: 'SATPU', label: 'Saturday Pickup' },
	{ value: 'SORTDEL', label: 'Sort/Segregate Delivery' },
	{ value: 'SORTPU', label: 'Sort/Segregate Pickup' },
	{ value: 'UTLDEL', label: 'Utility Site Delivery' },
	{ value: 'UTLPU', label: 'Utility Site Pickup' },
	{ value: 'WG30', label: 'White Glove Assembly 30 Mins' },
	{ value: 'WG60', label: 'White Glove Assembly 60 Mins' },
];

// Preselected on new carriers. Mirrors the v1_0_222 backfill that seeds the same codes on existing
// LTL carriers, so keep the two in step.
const defaultCarrierAccessorials = ['RESDEL', 'LGDEL'];

export { carrierAccessorials, defaultCarrierAccessorials };
